import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2af429c1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af429c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af429c1')) {
      api.createRecord('2af429c1', component.options)
    } else {
      api.reload('2af429c1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2af429c1&scoped=true", function () {
      api.rerender('2af429c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/trajectoryPushBoard/index.vue"
export default component.exports